import React from 'react'
import styles from "./row.module.scss"

const Row = (props) => {
  return (
    <div className={`${styles.container} ${props.className}`}>
        {props.children}
    </div>
  )
}

export default Row